import React from "react";

export default function ForecastDay(props){

    function maxTemp(){
        let temperature = Math.round(props.data.temperature.maximum);
        return temperature;
    }

    function minTemp(){
        let temperature = Math.round(props.data.temperature.minimum);
        return temperature;
    }

    function day(){
        let date = new Date (props.data.time * 1000);
        let day = date.getDay();
        let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        return days[day];
    }

return(
    <div className="col nextDayCard gap">
         <h3>{day()}</h3>
         <img src={props.data.condition.icon_url} alt={props.data.condition.description}></img>
         <h3>{maxTemp()}° | {minTemp()}°</h3>
     </div>
                
)
}